import { displayFlex, JAKARTA_SEMI } from '@onhandtech/onhand-toolkit'
import styled from 'styled-components'

export const NavigationBar = styled.nav`
  width: 100%;
  height: 4rem;
  background: ${({ theme }) => theme.colours.cotton};
  padding: 0;
  border-bottom: solid 1px ${({ theme }) => theme.colours.pebble};
  ${displayFlex({ justifyContent: 'space-between' })}
`

export const LogoContainer = styled.span`
  background: ${({ theme }) => theme.colours.earth};
  height: 100%;
  width: 4.5rem;
  ${displayFlex()}
`

export const Logo = styled.span`
  ${displayFlex()}
`

export const LogOutButton = styled.button`
  ${displayFlex({ justifyContent: 'space-between', gap: '0.6rem' })}
  font-family: ${JAKARTA_SEMI};
  font-size: 1rem;
  margin-right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
`
